
import { SQLCourse } from './types';
import { phase2Modules } from './phase2Modules';

export const SQL_PHASE2_COURSE: SQLCourse = {
  id: "sql-phase2-analytics",
  title: "Advanced SQL Analytics & Cloud Databases",
  description: "Master modern data analytics with SQL and learn cloud database platforms including AWS, Google Cloud, and Azure.",
  level: "advanced",
  durationHours: 12,
  tags: ["Advanced Analytics", "Cloud Databases", "JSON", "Time Series", "Statistics", "AWS", "GCP", "Azure"],
  imageSrc: "/placeholder.svg",
  image: "/placeholder.svg",
  modules: phase2Modules,
  totalDuration: "6 hours",
  requirements: [
    "Completion of SQL Intermediate course",
    "Understanding of basic statistics",
    "Familiarity with cloud computing concepts"
  ]
};
